import React from 'react';
import Header from '../Layout/Header';
import Banner from './Banner';
// import Helping from './Helping';
import ProjectList from './ProjectList';
import Footer from '../Layout/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import config from '../../config';
import CookieBanner from './cookieBanner';
import EmpowerInvestment from './EmpowerInvestment';
import Security from './SubFooter';

export default function LaunchpadHome() {
  const navigate = useNavigate();
  document.body.classList.remove('dark-mode');
  document.body.classList.remove('light-mode');

  return (
    <>
      <Header />
      <Banner />
      {/* <Helping /> */}
      <EmpowerInvestment />
      <div className="bg-darkgrey">
        <ProjectList />
        {/* <LaunchProject /> */}
        <Security />
        <Footer />
      </div>
      <CookieBanner />
    </>
  );
}
